import jQuery from 'jquery';
import 'hammerjs';
import 'lazysizes';
import 'nanoscroller';
import Handlebars from 'handlebars/dist/handlebars';
import * as Popper from '@popperjs/core';
import * as bootstrap from 'bootstrap';

window.jQuery = jQuery;
window.$ = jQuery;
window.Handlebars = Handlebars;
window.Popper = Popper;
window.bootstrap = bootstrap;
